/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { importAlertState } from '../../redux/actions/alert';
import {
  JOURNAL_ENTRY_SAVE_RULE_ACTION,
  clearJournalEntryRuleSaveOffer,
  openJournalEntryRuleSaveModal,
} from '../general/js/forms/reconcile/contabilidad/journalEntryRuleSaveBridge';
import moment from 'moment';
import './style.scss';

const DEFAULT_CLOSE_TIME = 4000;

const TOAST_OPTIONS = {
  position: 'top-right',
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: 'light',
};

const clearAlertState = (dispatch) => {
  dispatch(
    importAlertState({
      content: '',
      state: '',
      duration: 0,
    }),
  );
};

export default function Alert({ alertState }) {
  const dispatch = useDispatch();
  const loadingToastIdRef = useRef(null);
  const loadingFallbackTimeoutRef = useRef(null);

  const dismissLoadingToast = () => {
    if (loadingFallbackTimeoutRef.current) {
      clearTimeout(loadingFallbackTimeoutRef.current);
      loadingFallbackTimeoutRef.current = null;
    }
    if (loadingToastIdRef.current != null) {
      toast.dismiss(loadingToastIdRef.current);
      loadingToastIdRef.current = null;
    }
  };

  useEffect(() => () => dismissLoadingToast(), []);

  useEffect(() => {
    if (!alertState.state) {
      return;
    }

    if (alertState?.duration === 0) {
      return;
    }

    const autoCloseMs =
      alertState?.duration > 0 ? alertState.duration * 1000 : DEFAULT_CLOSE_TIME;

    const handleToastAction = (event) => {
      event?.stopPropagation?.();
      if (alertState.actionId === JOURNAL_ENTRY_SAVE_RULE_ACTION) {
        openJournalEntryRuleSaveModal();
        toast.dismiss();
        clearAlertState(dispatch);
      }
    };

    const message = (
      <div className="toastMessage mr-2">
        <div className="toastUpper">
          <span className="toastConceptText font-weight-bold">
            {alertState.concept
              ? alertState.concept
              : alertState.state === 'loading'
                ? 'Espere un momento'
                : alertState.state === 'error'
                  ? 'Error'
                  : 'Éxito!'}
          </span>
          <span className="toastTime">
            {moment(alertState.time).format('DD/MM/YYYY HH:MM:SS')}
          </span>
        </div>
        <div className="toastLower">
          {alertState.content}
          {alertState.actionLabel ? (
            <button
              type="button"
              className="toastActionLink"
              onClick={handleToastAction}
            >
              {alertState.actionLabel}
            </button>
          ) : null}
        </div>
      </div>
    );

    if (alertState.state === 'loading') {
      dismissLoadingToast();
      const toastId = toast.loading(message, {
        ...TOAST_OPTIONS,
        autoClose: false,
      });
      loadingToastIdRef.current = toastId;
      loadingFallbackTimeoutRef.current = setTimeout(() => {
        dismissLoadingToast();
      }, autoCloseMs);
      clearAlertState(dispatch);
      return;
    }

    const isRuleSaveToast =
      alertState.actionId === JOURNAL_ENTRY_SAVE_RULE_ACTION;

    dismissLoadingToast();
    toast(message, {
      ...TOAST_OPTIONS,
      // Mismo botlog (u origen) → un solo toast aunque disparemos 2 veces.
      toastId: alertState.toastKey || undefined,
      type: alertState.state,
      autoClose: autoCloseMs,
      closeOnClick: !alertState.actionLabel,
      onClose: () => {
        if (isRuleSaveToast) {
          clearJournalEntryRuleSaveOffer();
        }
      },
    });
    setTimeout(() => {
      clearAlertState(dispatch);
      if (isRuleSaveToast) {
        clearJournalEntryRuleSaveOffer();
      }
    }, autoCloseMs);
  }, [alertState]);

  return <ToastContainer newestOnTop style={{ zIndex: 100000 }} />;
}
